"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringArray = void 0;
const is_array_of_type_1 = require("./is-array-of-type");
exports.isStringArray = (value) => is_array_of_type_1.isArrayOfType(value, "string");
//# sourceMappingURL=is-string-array.js.map